"use client";

import React from "react";
import { MapPin, Phone, Mail, Clock, Loader, ArrowRight, Terminal } from "lucide-react";
import { FormProvider, useWvcForm } from "@/integrations/forms/FormProvider";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Textarea } from "@/components/ui/textarea";
import { Form, FormField, FormItem, FormLabel, FormControl, FormMessage, FormDescription } from "@/components/ui/form";
function AnalysisForm() {
  const {
    isSubmitting,
    isSubmitted,
    submitError,
    successMessage,
    handleSubmit,
    resetForm,
    control
  } = useWvcForm();
  if (isSubmitted && !submitError) {
    return <div className="flex flex-col items-center justify-center py-12 text-center space-y-4 animate-in fade-in duration-500">
        <div className="w-16 h-16 rounded-lg bg-secondary/20 flex items-center justify-center mb-4">
          <Terminal className="w-8 h-8 text-secondary" />
        </div>
        <h3 className="font-default text-2xl font-bold text-foreground">Segnalazione Inviata</h3>
        <p className="text-muted-foreground max-w-md">{successMessage}</p>
        <Button onClick={resetForm} variant="outline" className="mt-6 border-primary/50 hover:bg-primary/10 text-primary">
          Invia un'altra segnalazione
        </Button>
      </div>;
  }
  return <Form onSubmit={handleSubmit} className="space-y-6">
      <div className="grid grid-cols-1 md:grid-cols-2 gap-4 md:gap-6">
        <FormField control={control} name="name" rules={{
        required: "Il nome è obbligatorio"
      }} render={({
        field
      }) => <FormItem>
              <FormLabel className="font-default text-xs uppercase tracking-wider text-muted-foreground">Nome e Cognome</FormLabel>
              <FormControl>
                <Input placeholder="Mario Rossi" {...field} className="bg-background border-border focus-visible:border-primary" />
              </FormControl>
              <FormMessage />
            </FormItem>} />

        <FormField control={control} name="email" rules={{
        required: "L'email è obbligatoria",
        pattern: {
          value: /^[^\s@]+@[^\s@]+\.[^\s@]+$/,
          message: "Formato email non valido"
        }
      }} render={({
        field
      }) => <FormItem>
              <FormLabel className="font-default text-xs uppercase tracking-wider text-muted-foreground">Indirizzo Email</FormLabel>
              <FormControl>
                <Input type="email" placeholder="mario.rossi@esempio.it" {...field} className="bg-background border-border focus-visible:border-primary" />
              </FormControl>
              <FormMessage />
            </FormItem>} />
      </div>

      <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
        <FormField control={control} name="phone" rules={{
        required: "Il numero di telefono è obbligatorio"
      }} render={({
        field
      }) => <FormItem>
              <FormLabel className="font-default text-xs uppercase tracking-wider text-muted-foreground">Telefono</FormLabel>
              <FormControl>
                <Input type="tel" placeholder="+39 06 1234567" {...field} className="bg-background border-border focus-visible:border-primary" />
              </FormControl>
              <FormDescription className="font-default text-[10px]">Inserisci un recapito valido per essere ricontattato.</FormDescription>
              <FormMessage />
            </FormItem>} />

        <FormField control={control} name="zona" rules={{
        required: "Seleziona una zona"
      }} render={({
        field
      }) => <FormItem>
              <FormLabel className="font-default text-xs uppercase tracking-wider text-muted-foreground">Zona di Riferimento</FormLabel>
              <FormControl>
                <div className="relative">
                  <select {...field} className="flex h-9 w-full appearance-none rounded-md border border-border bg-background px-3 py-1 text-base shadow-sm transition-[color,box-shadow] outline-none focus-visible:border-primary focus-visible:ring-[3px] focus-visible:ring-primary/20 disabled:cursor-not-allowed disabled:opacity-50 md:text-sm text-foreground">
                    <option value="" disabled>Seleziona la tua zona</option>
                    {["Albano", "Pavona", "Cecchina"].map((opt, i) => <option key={i} value={opt} className="bg-background text-foreground">
                        {opt}
                      </option>)}
                  </select>
                  <div className="pointer-events-none absolute inset-y-0 right-0 flex items-center px-2 text-muted-foreground">
                    <svg className="h-4 w-4 fill-current" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20">
                      <path d="M9.293 12.95l.707.707L15.657 8l-1.414-1.414L10 10.828 5.757 6.586 4.343 8z" />
                    </svg>
                  </div>
                </div>
              </FormControl>
              <FormMessage />
            </FormItem>} />
      </div>

      <FormField control={control} name="description" rules={{
      required: "Il messaggio è obbligatorio"
    }} render={({
      field
    }) => <FormItem>
            <FormLabel className="font-default text-xs uppercase tracking-wider text-muted-foreground">La tua segnalazione o idea</FormLabel>
            <FormControl>
              <Textarea placeholder="Descrivi brevemente la tua proposta per migliorare la nostra città..." className="min-h-[120px] bg-background border-border focus-visible:border-primary resize-y" {...field} />
            </FormControl>
            <FormMessage />
          </FormItem>} />

      {submitError && <div className="p-4 bg-destructive/10 border border-destructive/20 rounded-md">
          <p className="text-destructive text-sm font-default flex items-center gap-2">
            <span className="w-2 h-2 bg-destructive rounded-lg animate-pulse"></span>
            Errore di sistema: {submitError}
          </p>
        </div>}

      <Button type="submit" disabled={isSubmitting} className="w-full h-12 text-base font-bold tracking-wide uppercase group relative overflow-hidden bg-secondary text-secondary-foreground hover:bg-secondary/90 rounded-md">
        <span className="relative flex items-center justify-center gap-2">
          {isSubmitting ? <>
              <Loader className="animate-spin size-5" />
              Invio in corso...
            </> : <>
              Invia Segnalazione
              <ArrowRight className="size-5 group-hover:translate-x-1 transition-transform" />
            </>}
        </span>
      </Button>
    </Form>;
}
export default function StartYourProjectAnalysis() {
  return <section data-section-id="224949" id="partecipa" className="bg-background text-foreground relative">
      {}
      <div className="bg-background text-foreground py-24 lg:py-32 relative overflow-hidden">
        
        {}
        <div className="absolute inset-0 bg-[radial-gradient(ellipse_at_top_right,_var(--tw-gradient-stops))] from-primary/5 via-background to-background pointer-events-none"></div>
        <div className="absolute top-0 left-0 w-full h-px bg-gradient-to-r from-transparent via-border to-transparent"></div>
        <div className="absolute bottom-0 left-0 w-full h-px bg-gradient-to-r from-transparent via-border to-transparent"></div>
        
        {}
        <div className="absolute inset-0 bg-[linear-gradient(to_right,#80808008_1px,transparent_1px),linear-gradient(to_bottom,#80808008_1px,transparent_1px)] bg-[size:32px_32px] pointer-events-none"></div>

        <div className="container mx-auto px-4 md:px-6 relative z-10">
          <div className="grid grid-cols-1 lg:grid-cols-12 gap-6 md:gap-12 lg:gap-8 items-start">
            
            {}
            <div className="lg:col-span-5 flex flex-col space-y-8">
              <div>
                <div className="inline-flex items-center gap-2 px-3 py-1 rounded-lg bg-primary/10 border border-primary/20 text-primary font-default text-xs uppercase tracking-widest mb-6">
                  <span className="w-1.5 h-1.5 rounded-lg bg-primary animate-pulse"></span>
                  Partecipa Attivamente
                </div>
                <h2 className="font-default text-2xl md:text-4xl lg:text-5xl font-bold text-primary mb-4 tracking-tight">
                  Partecipa al <br /><span className="text-secondary">Cambiamento</span>
                </h2>
                <p className="text-muted-foreground text-base md:text-lg max-w-md">
                  La tua voce è fondamentale per costruire il futuro di Albano. Inviaci le tue segnalazioni, idee e proposte per migliorare il nostro territorio.
                </p>
              </div>

              {}
              <div className="border border-border bg-muted/30 backdrop-blur-sm rounded-md p-8 relative overflow-hidden group shadow-sm">
                {}
                <div className="absolute top-0 left-0 w-full h-px bg-gradient-to-r from-secondary/0 via-secondary/50 to-secondary/0 opacity-0 group-hover:opacity-100 transition-opacity duration-700"></div>

                <h3 className="font-default text-xl font-semibold mb-8 flex items-center gap-3 text-primary">
                  <Terminal className="w-5 h-5 text-secondary" />
                  Contatti Diretti
                </h3>

                <div className="space-y-6 font-default text-sm">
                  <div className="flex items-start gap-4 group/item">
                    <div className="p-2 rounded-md bg-primary/10 text-primary group-hover/item:bg-primary group-hover/item:text-primary-foreground transition-colors">
                      <MapPin className="w-4 h-4" />
                    </div>
                    <div>
                      <div className="text-muted-foreground text-xs uppercase tracking-wider mb-1">Sede Elettorale</div>
                      <div className="text-foreground">Via Cavour, Albano Laziale</div>
                    </div>
                  </div>
                  
                  <div className="flex items-start gap-4 group/item"><div className="p-2 rounded-md bg-primary/10 text-primary group-hover/item:bg-primary group-hover/item:text-primary-foreground transition-colors" data-ast-id="f:/src/pages/Home/sections/StartYourProjectAnalysis.tsx|sig:74wedd" data-ast-start="10126" data-ast-end="10351"><svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" className="lucide lucide-phone w-4 h-4" aria-hidden="true" data-ast-id="f:/src/pages/Home/sections/StartYourProjectAnalysis.tsx|sig:pqzi6e" data-ast-start="10295" data-ast-end="10324"><path d="M13.832 16.568a1 1 0 0 0 1.213-.303l.355-.465A2 2 0 0 1 17 15h3a2 2 0 0 1 2 2v3a2 2 0 0 1-2 2A18 18 0 0 1 2 4a2 2 0 0 1 2-2h3a2 2 0 0 1 2 2v3a2 2 0 0 1-.8 1.6l-.468.351a1 1 0 0 0-.292 1.233 14 14 0 0 0 6.392 6.384"></path></svg></div><div data-ast-id="f:/src/pages/Home/sections/StartYourProjectAnalysis.tsx|sig:xbpsbj" data-ast-start="10372" data-ast-end="10600"><div className="text-muted-foreground text-xs uppercase tracking-wider mb-1" data-ast-id="f:/src/pages/Home/sections/StartYourProjectAnalysis.tsx|sig:t0f9l7" data-ast-start="10400" data-ast-end="10496">Linea Diretta</div><div className="text-foreground" data-ast-id="f:/src/pages/Home/sections/StartYourProjectAnalysis.tsx|sig:w50qwb" data-ast-start="10519" data-ast-end="10573">+39 3452416177</div></div></div>
                  
                  <div className="flex items-start gap-4 group/item">
                    <div className="p-2 rounded-md bg-primary/10 text-primary group-hover/item:bg-primary group-hover/item:text-primary-foreground transition-colors">
                      <Mail className="w-4 h-4" />
                    </div>
                    <div>
                      <div className="text-muted-foreground text-xs uppercase tracking-wider mb-1">Email Comitato</div>
                      <div className="text-foreground">info@borellisindaco.it</div>
                    </div>
                  </div>
                  
                  <div className="flex items-start gap-4 group/item">
                    <div className="p-2 rounded-md bg-primary/10 text-primary group-hover/item:bg-primary group-hover/item:text-primary-foreground transition-colors">
                      <Clock className="w-4 h-4" />
                    </div>
                    <div>
                      <div className="text-muted-foreground text-xs uppercase tracking-wider mb-1">Orari di Ascolto</div>
                      <div className="text-foreground">Lunedì - Sabato: 09:00 - 19:00</div>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            {}
            <div className="lg:col-span-7">
              <div className="bg-card border border-border rounded-md p-6 md:p-10 shadow-lg relative">
                {}
                <div className="absolute top-0 left-0 w-4 h-4 border-t-2 border-l-2 border-secondary/50 rounded-tl-md"></div>
                <div className="absolute top-0 right-0 w-4 h-4 border-t-2 border-r-2 border-secondary/50 rounded-tr-md"></div>
                <div className="absolute bottom-0 left-0 w-4 h-4 border-b-2 border-l-2 border-secondary/50 rounded-bl-md"></div>
                <div className="absolute bottom-0 right-0 w-4 h-4 border-b-2 border-r-2 border-secondary/50 rounded-br-md"></div>

                <div className="mb-8 border-b border-border pb-6">
                  <h3 className="font-default text-2xl font-semibold text-primary">Invia la tua Proposta</h3>
                  <p className="text-muted-foreground mt-2 text-sm">Compila i campi sottostanti per far arrivare il tuo contributo direttamente al candidato.</p>
                </div>

                <FormProvider formKey="partecipa_form_home" formId="partecipa_form_home" sectionName="Partecipa al Cambiamento" defaultValues={{
                name: "",
                email: "",
                phone: "",
                zona: "",
                description: ""
              }} validationRules={{
                name: {
                  required: true
                },
                email: {
                  required: true,
                  pattern: "email"
                },
                phone: {
                  required: true
                },
                zona: {
                  required: true
                },
                description: {
                  required: true
                }
              }} submitText="Invia Segnalazione" successMessage="Grazie per il tuo contributo. La tua segnalazione è stata registrata correttamente.">
                  <AnalysisForm />
                </FormProvider>
              </div>
            </div>

          </div>
        </div>
      </div>
    </section>;
}